module.exports = __webpack_public_path__ + "img/xg.c68b83a2.png";